<div class="popup" style="display: flex; flex-direction: column; width: 250px;">
  <button (click)="registerSingleClick()">Register / Unregister toSingle-Click event</button>
  <button (click)="registerRighClick()">Register / Unregister to Right-Click event</button>
  <button (click)="registerDoubleClick()">Register / Unregister to Double-Click event</button>
</div>
